module.exports = __webpack_public_path__ + "static/media/office-building.2ddc6b2a.svg";